import { Component, input } from '@angular/core';
import { Icon } from '../icon/icon.component';
import { Size } from '../common/types';

@Component({
  selector: 'app-spinner',
  imports: [Icon],
  template: `
    <section class="flex items-center justify-center w-full h-full">
      <app-icon
        [size]="size()"
        class="animate-spin text-primary"
        name="mdi:loading"
      />
    </section>
  `,
})
export class Spinner {
  size = input<Size>('xl');
}
